.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0 0 var(--space-4);
  padding: 0;
  border: 0;
}

.legend {
  margin-bottom: var(--space-2);
  padding: 0;
  font-size: var(--text-sm);
  font-weight: 600;
}

.option {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  min-height: 56px;
  padding: var(--space-3);
  border-radius: var(--radius-md);
  background: var(--surface-panel);
  box-shadow: inset 0 0 0 1.5px var(--border);
  cursor: pointer;
  transition: box-shadow var(--dur) var(--ease-out);
}

.option:hover {
  box-shadow: inset 0 0 0 1.5px var(--border-strong);
}

.checked {
  background: var(--accent-tint);
  box-shadow: inset 0 0 0 2px var(--accent);
}

.radio {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  margin: 2px 0 0;
  accent-color: var(--accent);
}

.radio:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: 2px;
}

.text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.label {
  font-weight: 600;
}

.hint {
  color: var(--text-muted);
  font-size: var(--text-sm);
}
